@if (href) {
  <a [href]="href">
    <shared-icon [icon]="icon" width="1.25rem" height="1.25rem" [style.fill]="textColorHex" />
    <span [style.color]="textColorHex">{{ label }}</span>
  </a>
} @else {
  <a [routerLink]="routerLink" [routerLinkActive]="'active'">
    <shared-icon [icon]="icon" width="1.25rem" height="1.25rem" [style.fill]="textColorHex" />
    <span [style.color]="textColorHex">{{ label }}</span>
  </a>
}
